export default "__VITE_ASSET__Ct7ope0t__"